import {
  ActionIcon,
  Card,
  Checkbox,
  Collapse,
  Divider,
  Group,
  Stack,
  Text,
  Title,
} from '@mantine/core'
import { IconCaretDown, IconCaretUp, IconInfoSquare, IconLayout } from '@tabler/icons-react'
import { useTranslate } from 'react-admin'
import { useVideoPromotionStore } from '../../../stores/useVideoPromotionStore'
import { NewPromotionActions } from '../../../types/components/VideoPromotion.type'
import { NewPromotionElementEndscreen } from './NewPromotionElementEndscreen/NewPromotionElementEndscreen'
import { NewPromotionElementInfocard } from './NewPromotionElementInfocard/NewPromotionElementInfocard'

type ConfigElement = { id: NewPromotionActions; icon: typeof IconLayout; content: JSX.Element }

export const NewPromotionElementsConfiguration = () => {
  const t = useTranslate()
  const videoPromotionStore = useVideoPromotionStore()
  const configElementsCards: ConfigElement[] = [
    { id: 'endScreen', icon: IconLayout, content: <NewPromotionElementEndscreen /> },
    { id: 'infoCards', icon: IconInfoSquare, content: <NewPromotionElementInfocard /> },
  ]

  return (
    <Stack>
      <Group align="flex-end" w="100%">
        <Text c="dimmed" opacity={0.8}>
          {videoPromotionStore.youtubeVideoIds.length}&nbsp;
          {t('pages.videoPromotion.selectedVideo_other')}
        </Text>
      </Group>
      {configElementsCards.map(cec => (
        <Card key={cec.id} radius="sm" p="md" withBorder>
          <Group wrap="nowrap" align="flex-start" h="100%" pr="sm" w="100%">
            <Checkbox
              checked={videoPromotionStore.elementsConfiguration[cec.id].active}
              mt={5}
              styles={{ input: { cursor: 'pointer' } }}
              onChange={() => videoPromotionStore.toggleElementsConfig(cec.id)}
            />
            <Stack flex={1}>
              <Group
                justify="space-between"
                onClick={() => videoPromotionStore.toggleElementsConfig(cec.id)}
                w="100%"
                style={{
                  cursor: 'pointer',
                }}
              >
                <Group gap="xs">
                  <cec.icon size={24} />
                  <Title order={3}>{t(`pages.videoPromotion.${cec.id}._title`)}</Title>
                </Group>
                <ActionIcon variant="subtle" size="lg" c="dark">
                  {videoPromotionStore.elementsConfiguration[cec.id].active ? (
                    <IconCaretUp size={32} stroke={1.3} />
                  ) : (
                    <IconCaretDown size={32} stroke={1.3} />
                  )}
                </ActionIcon>
              </Group>
              <Collapse in={videoPromotionStore.elementsConfiguration[cec.id].active}>
                <Divider w="100%" />
                {cec.content}
              </Collapse>
            </Stack>
          </Group>
        </Card>
      ))}
    </Stack>
  )
}
